<template>
  <div class="pipeline-filter">
    <div class="pipeline-filter-header">
      <div class="modal-title">Confirmar Mensagem Rápida</div>

      <i @click="$emit('close')" class="icon-close-circle-outline" />
    </div>

    <div class="content-modal-holder nice-Vscroll" ref="formValidation">
      <div class="title-text">Mensagem:</div>

      <textarea rows="5" class="form-control" v-model="quickMessage.content" />

      <div class="title-text">Arquivo:</div>

      <div class="file-holder">
        <img
          v-if="getMimeType(quickMessage.file?.mime) == 'image'"
          :src="quickMessage.file.url"
          :alt="quickMessage.file.name"
          class="visual-file"
        />

        <div v-else-if="getMimeType(quickMessage.file?.mime) == 'sticker'" class="sticker-file">
          Sticker ainda não suportado!
        </div>

        <video v-else-if="getMimeType(quickMessage.file?.mime) == 'video'" class="visual-file" controls>
          <source :src="quickMessage.file.url" />
          Seu navegador não suporta a reprodução de vídeos.
        </video>

        <div
          v-else-if="
            getMimeType(quickMessage.file?.mime) == 'document' && isPreviewableDocument(quickMessage.file)
          "
          class="document-preview-wrapper"
        >
          <div v-if="quickMessage.file.mime === 'application/pdf'" class="pdf-preview-card">
            <object
              :data="pdfViewerUrl(quickMessage.file)"
              type="application/pdf"
              class="pdf-object nice-Vscroll"
            >
              Prévia indisponível.
            </object>

            <div class="doc-meta-row">
              <feather-icon icon="FileTextIcon" size="18" />

              <span class="file-name" :title="quickMessage.file.name">
                {{ quickMessage.file.name }}
              </span>

              <span @click="openDocumentInBlank(quickMessage.file)" class="preview-action">
                <Icon icon="gridicons:external" />
              </span>

              <span @click.prevent="downloadFile(quickMessage.file)" class="preview-action">
                <Icon icon="material-symbols:download" />
              </span>
            </div>
          </div>

          <div v-else class="text-preview-card" :class="{ expanded: isExpanded }">
            <div class="text-preview-header">
              <feather-icon icon="FileTextIcon" size="18" />

              <span class="file-name" :title="quickMessage.file.name">
                {{ quickMessage.file.name }}
              </span>

              <span @click="openDocumentInBlank(quickMessage.file)" class="preview-action">
                <Icon icon="gridicons:external" />
              </span>

              <span @click.prevent="downloadFile(quickMessage.file)" class="preview-action">
                <Icon icon="material-symbols:download" />
              </span>

              <span class="preview-action" @click="togglePreview()">
                <Icon :icon="isExpanded ? 'mdi:eye-off-outline' : 'mdi:eye-outline'" />
              </span>
            </div>

            <div class="text-preview-body nice-Vscroll" v-if="isExpanded">
              <b-spinner small v-if="previewLoading" />

              <pre v-else-if="previewContent" class="text-content">
              {{ previewContent }}
            </pre
              >

              <div v-else-if="previewError" class="preview-error">
                Prévia não carregada: {{ previewError }}
              </div>

              <div v-else class="preview-hint">Carregando...</div>
            </div>
          </div>
        </div>

        <a
          v-else-if="getMimeType(quickMessage.file?.mime) == 'document'"
          class="document-file"
          target="_blank"
          rel="noopener"
        >
          <div class="file-name">{{ quickMessage.file.name }}</div>

          <i class="icon-arrow-down" />
        </a>
      </div>

      <div class="warning-holder">
        <feather-icon icon="InfoIcon" class="warning-icon" color="#046af3" size="25" />

        <div class="warning-text">
          Ao confirmar, a mensagem rápida será enviada diretamente juntamente com o arquivo anexado.
        </div>
      </div>
    </div>

    <div class="bottom-menu">
      <b-button @click="$emit('close')" variant="light">Cancelar</b-button>

      <b-button @click="confirm()" variant="primary">Confirmar</b-button>
    </div>
  </div>
</template>

<script>
import { BButton, BSpinner } from "bootstrap-vue";
import { Icon } from "@iconify/vue2";

export default {
  components: {
    BButton,
    BSpinner,
    Icon,
  },

  data() {
    return {
      isExpanded: false,

      previewLoading: false,
      previewContent: null,
      previewError: null,

      previewableTextMimes: ["text/plain", "text/csv", "text/tsv", "text/html", "text/rtf"],
    };
  },

  props: {
    quickMessage: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    openDocumentInBlank(file) {
      if (!file) return;

      window.open(file.url, "_blank");
    },

    pdfViewerUrl(file) {
      if (!file) return null;

      return file.url + "#toolbar=0&navpanes=0&scrollbar=0&page=1";
    },

    isPreviewableDocument(file) {
      if (!file || !file.mime) return false;

      if (file.mime === "application/pdf") return true;

      return this.previewableTextMimes.includes(file.mime);
    },

    togglePreview() {
      if (
        !this.previewContent &&
        !this.previewLoading &&
        !this.previewError &&
        this.quickMessage.file?.mime !== "application/pdf"
      ) {
        this.loadTextPreview();
      }

      this.isExpanded = !this.isExpanded;
    },

    loadTextPreview() {
      const file = this.quickMessage.file;

      if (!this.isPreviewableDocument(file)) return;

      if (file.mime === "application/pdf") return;

      if (this.previewLoading || this.previewContent) return;

      this.previewLoading = true;
      this.previewError = null;

      fetch(file.url)
        .then((r) => r.text())
        .then((text) => {
          const truncated = text.length > 4000 ? text.slice(0, 4000) + "\n..." : text;
          this.previewContent = truncated;
          this.previewLoading = false;
        })
        .catch((e) => {
          this.previewError = e.message || "Erro ao carregar prévia";
          this.previewLoading = false;
          this.previewContent = null;
        });
    },

    getMimeType(type) {
      if (!type) return null;

      const possibleTypes = {
        "audio/aac": "audio",
        "audio/mp4": "audio",
        "audio/amr": "audio",
        "audio/mpeg": "audio",
        "audio/ogg": "audio",
        "audio/mp3": "audio",
        "audio/wav": "audio",
        "audio/opus": "audio",
        "audio/webm": "audio",
        "audio/x-wav": "audio",
        "audio/vnd.wave": "audio",

        "image/jpeg": "image",
        "image/png": "image",
        "image/gif": "image",
        "image/tiff": "image",

        "image/webp": "sticker",

        "video/mp4": "video",
        "video/3gpp": "video",

        "text/plain": "document",
        "text/csv": "document",
        "text/tsv": "document",
        "text/html": "document",
        "text/rtf": "document",

        "application/pdf": "document",
        "application/msword": "document",
        "application/vnd.ms-powerpoint": "document",
        "application/vnd.ms-excel": "document",
        "application/vnd.ms-access": "document",

        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "document",
        "application/xlsx": "document",
        "application/octet-stream": "document",

        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "document",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": "document",

        "application/vnd.oasis.opendocument.text": "document",
        "application/vnd.oasis.opendocument.spreadsheet": "document",
        "application/vnd.oasis.opendocument.presentation": "document",

        "application/zip": "document",
        "application/x-7z-compressed": "document",
        "application/x-rar-compressed": "document",
        "application/gzip": "document",
        "application/x-tar": "document",

        "application/vnd.android.package-archive": "document",
        "application/vnd.apple.pkpass": "document",
        "application/vnd.adobe.photoshop": "document",
      };

      if (!possibleTypes[type]) return "document";

      let documentType = possibleTypes[type];

      return documentType;
    },

    downloadFile(file) {
      if (!file || !file.url) return;

      const filename = file.name || "arquivo";

      fetch(file.url, { mode: "cors" })
        .then((r) => r.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.href = blobUrl;
          a.download = filename;

          document.body.appendChild(a);

          a.click();
          a.remove();

          setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
        })
        .catch(() => {
          const a = document.createElement("a");

          a.href = file.url;
          a.setAttribute("download", filename);

          document.body.appendChild(a);

          a.click();
          a.remove();
        });
    },

    confirm() {
      this.$emit("confirm", this.quickMessage);
    },
  },
};
</script>

<style lang="scss" scoped>
.pipeline-filter {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 100dvh;
  width: 100%;
  overflow: hidden;

  .pipeline-filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 15px 10px;
    border-bottom: 1px solid #ececec;
    color: #31333f;

    .modal-title {
      font-size: 15px;
      font-weight: 600;
    }

    .icon-close-circle-outline {
      font-size: 22px;
    }
  }

  .content-modal-holder {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 1.5rem 1rem;
    gap: 15px;
    overflow-x: hidden;
    overflow-y: auto;

    .title-text {
      font-weight: 600;
      font-size: 18px;
      color: #6e6b7b;
    }

    .file-holder {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      border-radius: 10px;
      border: 1px solid #e2e6ea;
      overflow: hidden;

      .visual-file {
        width: 100%;
        border-radius: 10px;
      }

      .document-file {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        max-width: 350px;
        padding: 5px;
        border-radius: 16px 16px 16px 0px;
        background: #f0eff5;
        color: #0f1828;

        .file-name {
          line-height: 16px;
          letter-spacing: 0em;
          white-space: nowrap;
          text-overflow: ellipsis;
          height: 100%;
          padding: 1px 0;
          max-width: 80%;
          overflow: hidden;
        }

        i {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
          height: 40px;
          width: 40px;
          border-radius: 50%;
          background: #f0eff5;
          color: #0f1828;
        }
      }

      .document-preview-wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 5px;
        gap: 100px;
        color: #0f1828;

        .pdf-preview-card {
          display: flex;
          flex-direction: column;
          width: 100%;
          gap: 15px;

          .pdf-object {
            min-height: 260px;
            width: 100%;
            background: #ffffff;
          }

          .doc-meta-row {
            display: flex;
            align-items: center;
            gap: 6px;

            .file-name {
              flex: 1;
              font-size: 12px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }

        .text-preview-card {
          display: flex;
          flex-direction: column;
          gap: 15px;

          .text-preview-header {
            display: flex;
            align-items: center;
            gap: 6px;

            .file-name {
              flex: 1;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 12px;
              overflow: hidden;
            }
          }

          .text-preview-body {
            max-height: 260px;
            border-radius: 8px;
            border: 1px solid #e2e6ea;
            background: #ffffff;

            .text-content {
              white-space: pre-wrap;
              word-break: break-word;
              font-size: 12px;
              padding: 10px;
              margin: 0;
            }

            .preview-error {
              font-size: 12px;
              color: #c01220;
            }

            .preview-hint {
              font-size: 12px;
              color: #6c757d;
            }
          }
        }

        .preview-action {
          font-size: 20px;

          &:hover {
            color: #046af3;
          }
        }
      }
    }

    .warning-holder {
      display: flex;
      align-items: center;
      width: 100%;
      gap: 10px;
      padding: 10px;
      border: 1px solid #046af34d;
      border-radius: 6px;
      background: #e1edfe;

      .warning-icon {
        min-width: 25px;
      }

      .warning-text {
        text-align: center;
        color: #000;
      }
    }
  }

  .content-modal-holder > * {
    flex-shrink: 0;
  }

  .bottom-menu {
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-weight: bold;
    width: 100%;
    padding: 10px;
    margin-top: auto;
    border-top: 1px solid #ececec;
    color: #000000;
    background: #ffffff;
  }
}
</style>
